module.exports = __webpack_public_path__ + "static/media/editIconHover.2d82ee85.svg";